/** iPhone, iPod, or an iPad that reports itself as a Mac. */
export function isIOS(nav: Navigator = navigator): boolean {
  return /iPhone|iPad|iPod/.test(nav.userAgent) || (nav.platform === "MacIntel" && nav.maxTouchPoints > 1);
}

/** Android phones and tablets; a touchscreen laptop keeps its window (spec 2p §2.7). */
export function isAndroid(nav: Navigator = navigator): boolean {
  return /Android/i.test(nav.userAgent);
}

/** Opened from the home screen rather than in a browser tab. */
export function isStandalone(win: Window = window): boolean {
  if ((win.navigator as Navigator & { standalone?: boolean }).standalone === true) return true;
  return !!win.matchMedia?.("(display-mode: fullscreen)").matches || !!win.matchMedia?.("(display-mode: standalone)").matches;
}

export function canFullscreen(doc: Document = document): boolean {
  return !!doc.fullscreenEnabled && typeof doc.documentElement.requestFullscreen === "function";
}

/** Fullscreen, then landscape (a lock is only allowed in fullscreen); any refusal is quiet (spec 2p §2.7). */
export async function goFullscreen(doc: Document = document, scr: Screen = screen): Promise<void> {
  if (!canFullscreen(doc) || doc.fullscreenElement) return;
  try { await doc.documentElement.requestFullscreen({ navigationUI: "hide" }); } catch { return; }
  try { await (scr.orientation as ScreenOrientation & { lock?(o: string): Promise<void> } | undefined)?.lock?.("landscape"); } catch { /* not allowed here */ }
}

/** Android only: the first finger lift goes fullscreen. pointerup, not pointerdown: only a touch's lift counts as a user gesture. */
export function bindFirstTouchFullscreen(win: Window = window): void {
  let tried = false;
  win.addEventListener("pointerup", (e) => {
    if (tried || e.pointerType !== "touch" || !isAndroid(win.navigator)) return;
    tried = true;
    void goFullscreen(win.document, win.screen);
  }, true);
}
